import { z } from 'zod/v3';

export const EvidencePdfContentSchema = z.object({
  content: z.string(),
  filename: z.string(),
});
export type EvidencePdfContentDTO = z.infer<typeof EvidencePdfContentSchema>;

export type EvidencePdfStatusDTO =
  | { state: 'pending' }
  | { state: 'failed'; error: string }
  | { state: 'completed'; downloadUrl: string; fileName: string };
